import $ from 'jquery';

export function showLoadingSpinner(selector, size = '2rem') {
    const element = $(selector);
    element.html(`
        <div class="loading d-flex justify-content-center align-items-center w-100 h-100">
            <div class="spinner-border" role="status" style="width:${size};height:${size}">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
    `);
}

export function hideLoadingSpinner(selector) {
    const element = $(selector);
    element.empty();
}